export enum WorkStatus {
  Permanent = '01',
  Unemployed = '02',
  Student = '03',
  Housekeeper = '04',
  Retired = '05',
  GovernmentServant = '06',
  Contract_Parttime_Probation = '07',
  Others = '99'
}